/* eslint-disable no-shadow-restricted-names */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEmployeeContext } from "../../../context/employee-context";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { BaseURL } from "../../../lib/global-api";
import {
  getDateProperFormatForInput,
  getDateProperFormatForInputType2,
  getInputFieldProps,
  safeToString
} from "../../../utils/common";
import { logger, safeString } from "../../../utils/logger";
import { EMPLOYEE_API } from "../employee-constant";
import {
  DATE_DEPENDANCY,
  EMPLOYEE_FORM_FIELDS,
  EMPLOYEE_INITIAL_STATE,
} from "./profile-constant";
import { employeeValidationSchema } from "./profile-validation";
import { all } from "axios";
import DefaultRenderEmpty from "antd/es/config-provider/defaultRenderEmpty";

const useEmployeeProfileService = () => {

  const navigate = useNavigate()
  const fileInputRef = useRef(null);
  const {
    employeeProfileUILoading,
    setEmployeeProfileUILoading,
    employeeInfo: imployeeInfoFromDB,
    getProfileInfoFn,
    stateList,
    employeeID
  } = useEmployeeContext() || {};
   const { id } = useParams();
  const [employeeProfile, setEmployeeProfile] = useState(false)
  const employeeProfileModalOpen = () => {
    resetFunction()
    setEmployeeProfile(true)
  }

  const employeeProfileModalClose = () => setEmployeeProfile(false)

  const [PersonalInformation, setPersonalInformation] = useState(false);
  const [Employeedetails, setEmployeedetails] = useState(false);
  const EmployeedetailsModalOpen = () => {
    resetFunction()
    setEmployeedetails(true);
  }
  const EmployeedetailsModalClose = () => setEmployeedetails(false);
  const PersonalInformationModalOpen = () => {
    resetFunction()
    setPersonalInformation(true);
  }

  const PersonalInformationModalClose = () => setPersonalInformation(false);

  const [Permanentaddress, setPermanentaddress] = useState(false);
  const PermanentaddressModalOpen = () =>{
    resetFunction()
    setPermanentaddress(true)
  };
  const PermanentaddressModalClose = () => setPermanentaddress(false);

  const [Presentaddress, setPresentaddress] = useState(false);
  const PresentaddressModalOpen = () => {
    resetFunction()
    setPresentaddress(true);
  }
  const PresentaddressModalClose = () => setPresentaddress(false);
  const { showToastMessage } = useToast();

  const [employeeProfileInput, setEmployeeProfileInput] = useState(
    EMPLOYEE_INITIAL_STATE
  );

  const [isOpenPresentAddForm,setIsOpenPresentAddForm]=useState(false)
  const handleClickPresentAddress=()=>{
    setIsOpenPresentAddForm(!isOpenPresentAddForm)
  }

  useEffect(() => {
if(id===undefined){
  setEmployeeProfileInput(EMPLOYEE_INITIAL_STATE)
}
  }, [id])
 

  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const { fetchData } = useAPIHandler();

  const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);

  const [afterSubmitEmpId, setAfterSubmitEmpId] = useState(null)

  function resetOrganizationFormFn() {
    const resData = { ...imployeeInfoFromDB, country: "India" };

    resData.date_of_org = getDateProperFormatForInput(
      imployeeInfoFromDB?.date_of_org
    );

    if (imployeeInfoFromDB?.pincode) {
      resData.pincode = safeString(imployeeInfoFromDB?.pincode);
    }
    setEmployeeProfileInput(resData);

    if (imployeeInfoFromDB?.logo && imployeeInfoFromDB?.path) {
      setPreviewURL(
        `${BaseURL}/${imployeeInfoFromDB?.path}/${imployeeInfoFromDB?.logo}/`
      );
    }
    employeeProfileModalClose()
    PresentaddressModalClose();
    PermanentaddressModalClose();
    PersonalInformationModalClose();
    EmployeedetailsModalClose();
  }

  useEffect(() => {
    if (imployeeInfoFromDB?.first_name) {
      resetOrganizationFormFn();
    }
  }, [imployeeInfoFromDB]);

  const handleChangeFunction = (e, name) => {
    let value = e;

    // if (e && e.target) {
    //   value = e.target.value;
    // }
    if (e?.target) {
      value = e.target.value;
    } else {
      value = e;
    }

    if (
      EMPLOYEE_FORM_FIELDS[name].customOptions &&
      EMPLOYEE_FORM_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = EMPLOYEE_FORM_FIELDS[name].customOptions?.formatValueFn(
        value,
        employeeProfileInput
      );
    }

    setEmployeeProfileInput((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));


    if (DATE_DEPENDANCY.includes(name)) {

      DATE_DEPENDANCY.map(it => {
        if (employeeProfileInput[it] && it != name) {
          const fieldSchema = employeeValidationSchema.extract(it);
          const { error } = fieldSchema.validate(value, {
            context: {
              ...employeeProfileInput,
              [name]: value
            },
          });
          setErrors((prevErrors) => ({
            ...prevErrors,
            [it]: error ? error.details[0].message : undefined,
          }));

        }
      })
    }

    const fieldSchema = employeeValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: {
        ...employeeProfileInput,
        [name]: value

      },
    });

    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        showToastMessage({
          message: "File size should not exceed 2 MB.",
          color: "danger",
        });
        return;
      }
      const allowedTypes = ["image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        showToastMessage({
          message: "Only JPG files are allowed.",
          color: "danger",
        });
        return;
      }
      setSelectedFile(file); // Store the file in state
    }
  };

  const handleClick = async ({ file } = {}) => {
    setCreateFormUpdateLoading(true);

    const { error, value } = employeeValidationSchema.validate(
      employeeProfileInput,
      {
        abortEarly: false,
        context: {
          ...employeeProfileInput,
        },
      }
    );
    const { logo, ...allValue } = { ...value }
    let validationErrors = {};
      if (error && error?.details?.length > 0) {
      validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      logger.log("Validation Errors:", validationErrors);
    }
    // if (employeeProfileInput.employment_type != "full_time" || employeeProfileInput.employment_status != "provisionperiod") {
    //   delete validationErrors.provision_period_days
    // }
    if (employeeProfileInput.employment_type === "full_time") {
      delete validationErrors.provision_period_days
      delete validationErrors.contract_start
      delete validationErrors.contract_end
    }
    if (employeeProfileInput.employment_type === "probationary") {
      delete validationErrors.contract_start
      delete validationErrors.contract_end
    }
    delete validationErrors.qualification;

    const optionalFields = ['alternative_phone', 'personal_email'];
    // const optionalFields = ['personal_email'];

    optionalFields.forEach(field => {
      if (!allValue[field]) {
        allValue[field] = '';
      }
    });


    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setCreateFormUpdateLoading(false);
    } else {
      setErrors({});

      const data = new FormData();
      // if (value.date_of_birth) {
      //   value.date_of_birth = getDateProperFormatForInput(value.date_of_birth);
      // }
      // if (value.join_date) {
      //   value.join_date = getDateProperFormatForInput(value.join_date);
      // }
      const formatDate = (date) =>
        date instanceof Date
          ? date.toISOString().split("T")[0]
          : getDateProperFormatForInputType2(date);
      if (allValue.date_of_birth) {
        allValue.date_of_birth = formatDate(allValue.date_of_birth);
      }
      if (allValue.join_date) {
        allValue.join_date = formatDate(allValue.join_date);
      }
      if (allValue.contract_start) {
        allValue.contract_start = formatDate(allValue.contract_start);
      }
      if (allValue.contract_end) {
        allValue.contract_end = formatDate(allValue.contract_end);
      }

      if (value?.is_same_permanent === true) {
        const presetAddress = {
          present_address: value.permanent_address,
          present_city: value.permanent_city,
          present_state: value.permanent_state,
          present_pincode: value.permanent_pincode,
          present_landmark: value.permanent_landmark,
        };
        value.present_address = value.permanent_address;
        value.present_city = value.permanent_city;
        value.present_state = value.permanent_state;
        value.present_pincode = value.permanent_pincode;
        value.present_landmark = value.permanent_landmark;
        setEmployeeProfileInput((prev) => ({ ...prev, ...presetAddress }));
      }
      value.full_name = `${value.first_name} ${value.last_name} `;

      if (allValue?.employment_type === "full_time") {
        delete allValue.contract_start;
        delete allValue.contract_end
        // delete allValue.provision_period_days
        delete allValue.employment_status
        allValue.provision_period_days = ""
      }
      if (allValue?.employment_type === "probationary") {
        delete allValue.contract_start;
        delete allValue.contract_end
        delete allValue.employment_status
      }
      if (allValue?.employment_type === "part_time") {
        delete allValue.contract_start;
        delete allValue.contract_end
        delete allValue.provision_period_days
        delete allValue.employment_status
      }
      logger.log("allValue999", allValue)
        delete allValue.employee_image;
        delete allValue.contract_amount;
        delete allValue.employee_nominee;
        delete allValue.employee_statutories;
        delete allValue.employee_family;
        delete allValue.employee_benefits;
        delete allValue.base64logo;
      
      const isUpdate = !!employeeID;
      const something = ["employee_id", "user_id", "org_id", "exit_date", "permanent_location", "present_location", "created_at", "updated_at", "country", "date_of_org","blood_group","guardian_name","guardian_relationship","shift_type","employee_code","department_id","designation_id","marital_status","permanent_state","present_state","qualification"]
      const somethingForState=["designation_id","department_id","permanent_state","present_state","blood_group","marital_status","guardian_name","guardian_relationship","qualification"]
      logger.log(allValue,"allValue")
      Object.keys(allValue).map((key) => {
        if (isUpdate && something.includes(key)) {
          // data.append(key, allValue[key] ?? null);
          if(somethingForState && somethingForState.includes(key)){
            data.append(key, allValue[key] ?? "");
          }
        } else {
          data.append(key, allValue[key] ?? null);

        }
      });
      if (selectedFile || file) {
        data.append("logo", selectedFile || file);
      }

      try {
        const apiConfig = isUpdate ?
          { ...EMPLOYEE_API.EMPLOYEE_UPDATE, url: `${EMPLOYEE_API.EMPLOYEE_UPDATE.url}${employeeID}` }
          : { ...EMPLOYEE_API.EMPLOYEE_CREATE }
        const res = await fetchData({
          data,
          // ...EMPLOYEE_API.EMPLOYEE_CREATE,
          ...apiConfig
        });

        if (res?.data?.employee_id) {
          showToastMessage({ message: "Employee updated successfully!" });
        }
        const employeeId = res?.data?.employee_id
        setCreateFormUpdateLoading(false);
        getProfileInfoFn();

        PresentaddressModalClose();
        PermanentaddressModalClose();
        PersonalInformationModalClose();
        EmployeedetailsModalClose();
        // navigate(`/employee/profile/${employeeId}`)
        setAfterSubmitEmpId(employeeId)
        return employeeId;
      } catch (error) {
        if (error?.type === "JoiValidationError") {
          const errorsAll = {};

          error?.errors?.map((item) => {
            const { field, message } = item;
            errorsAll[field] = message;
          });

          showToastMessage({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });
          setErrors(errorsAll);
        }

        if (error?.type === "GeneralError") {
          showToastMessage({
            message: error.message || "An unknown general error occurred.",
            color: "danger",
          });
        }
        setCreateFormUpdateLoading(false);
      }
    }
  };

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = employeeValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: {
        ...employeeProfileInput,
      },
    });
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }

  }
  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      EMPLOYEE_FORM_FIELDS[fieldName] || {};

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: employeeProfileInput,
        type: restProps.type || "text",
        error,
        handleBlurFn,
        handleChangeFunction,
      }),



    };




    return props;
  };

  const togglePresentAddress = () => {
    setEmployeeProfileInput((prev) => ({
      ...prev,
      is_same_permanent: !prev.is_same_permanent,
    }));
  };
  const SubmitWithNextBtn = async () => {
    const employeeId = await handleClick();
    if (employeeId) {
      navigate(`/employee/statutoryKyc/${employeeId}`);
    }
  };

  const SubmitAfterView = async () => {
    const employeeId = await handleClick({ file: selectedFile });
    if (employeeId) {
      navigate(`/employee/${employeeId}`);
    }
  };
  logger.log("employeeProfileInput",employeeProfileInput)
  
  useEffect(() => {
    if (imployeeInfoFromDB?.logo) {
      setPreviewURL(imployeeInfoFromDB.logo);
    }
  }, [imployeeInfoFromDB]);

  const resetFunction = () => {
    if (!imployeeInfoFromDB) return;
    const resData = { ...imployeeInfoFromDB, country: "India" };

    resData.date_of_org = getDateProperFormatForInput(
      imployeeInfoFromDB?.date_of_org
    );

    if (imployeeInfoFromDB?.pincode) {
      resData.pincode = safeString(imployeeInfoFromDB?.pincode);
    }
    setEmployeeProfileInput(resData);

    if (imployeeInfoFromDB?.logo && imployeeInfoFromDB?.path) {
      setPreviewURL(
        `${BaseURL}/${imployeeInfoFromDB?.path}/${imployeeInfoFromDB?.logo}/`
      );
    }
    setErrors({})
  }
  return {
    setEmployeeProfileInput,
    fileInputRef,
    previewURL,
    getInputFieldProps: getInputFieldPropsFn,
    setSelectedFile,
    setPreviewURL,
    employeeProfileInput,
    handleClick,
    togglePresentAddress,
    EmployeedetailsModalOpen,
    PresentaddressModalClose,
    PresentaddressModalOpen,
    PermanentaddressModalClose,
    PermanentaddressModalOpen,
    PersonalInformationModalClose,
    PersonalInformationModalOpen,
    EmployeedetailsModalClose,
    employeeProfile,
    employeeProfileModalOpen,
    employeeProfileModalClose,
    Permanentaddress,
    PersonalInformation,
    Presentaddress,
    Employeedetails,
    createFormUpdateLoading,
    SubmitWithNextBtn,
    SubmitAfterView,
    handleFileChange,
    errors,
    id,
    isOpenPresentAddForm,
    handleClickPresentAddress,
  };
};

export default useEmployeeProfileService;